import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";
import { Slider } from "@platform/react-storybook/Component/Slider";
import { Sequential } from "@platform/utils/uuid";

import { DATA_CRACK } from "@common/content/crack";

import { ChallengesCard } from "@front/components/Element/Card/Challenges";
import { Text } from "@front/components/Element/Text/index";
import type { PropTypesChallengesCard } from "@front/components/Element/Card/Challenges/types";

import Rules from "./_rules.module.scss";
import type { PropTypesVerticalCardsSection, PropVerticalCardsSection } from "./types";

import {
    DEF_SECTION_CARD_VERTICAL,
    NAME_SECTION_CARD_VERTICAL,
    TYPE_SECTION_CARD_VERTICAL,
} from "./types";

import { SectionCard } from "..";
import type { PropTypesSectionCard } from "../types";

export function SectionCardVertical(props: PropVerticalCardsSection) {
    const { cards, hasTitle, title: titleSlider, ...rest } = props as PropTypesVerticalCardsSection;

    const cardType = ({
        bitmap,
        title,
        preset,
        "title-preset": titleP,
        href,
        desc,
        id,
        hasFade,
    }: PropTypesSectionCard) => {
        if (preset === "challenge") {
            const parameters: PropTypesChallengesCard = {
                key: Sequential(),
                bitmap,
                href,
                title,
                hasFade,
            };

            if (id) {
                const crack = DATA_CRACK.find(({ uuid }) => uuid === id);
                parameters["summary-text"] = `${crack?.nameFirst} ${crack?.nameLast}`;
            } else if (desc) {
                parameters.summary = desc;
            }

            return <ChallengesCard {...parameters} />;
        }
        return (
            <SectionCard
                key={Sequential()}
                bitmap={bitmap}
                href={href}
                preset={preset ?? "vertical-simple"}
                title={title}
                title-preset={titleP}
            />
        );
    };

    return (
        <Component
            {...rest}
            name={NAME_SECTION_CARD_VERTICAL}
            tag="section"
            type={TYPE_SECTION_CARD_VERTICAL}>
            {hasTitle && <Text raw className={Rules.title} preset="merlo" uuid={titleSlider} />}

            <Slider>
                {({ Slides }) => <Slides>{cards?.map((card) => cardType(card))}</Slides>}
            </Slider>
        </Component>
    );
}
SectionCardVertical.defaultProps = DEF_SECTION_CARD_VERTICAL;
